module.exports = __webpack_public_path__ + "static/media/frame-c-arrow-right-us.21efe80b.svg";